export function setSearch(state, text) {
  state.search = text;
}
export function setCategoryType(state, type) {
  state.category_type = type;
}
export function setCategory(state, category) {
  state.category = category;
}
export function setLicense(state, license) {
  state.license = license;
  if (license && !license.isAllLicenses) {
    //Prev license will be needed to recover right license after leaving inventory page.
    state.prev_license = license;
  }
}
export function setMinPrice(state, price) {
  state.min_price = price;
}
export function setMaxPrice(state, price) {
  state.max_price = price;
}
export function setOrderPerPage(state, value) {
  state.orders_per_page = value;
}
export function setProductsPerPage(state, value) {
  state.products_per_page = value;
}
export function setItemsPerPage(state, value) {
  state.items_per_page = value;
}
export function setInventoryPageLayout(state, value) {
  state.inventory_page_layout = value;
}
export function setItemsForNewProduct(state, items) {
  state.items_for_new_product = items;
}
export function setInventoryGroupingAvailable(state, available) {
  if (typeof state.inventory_grouping !== "undefined") {
    if (state.inventory_grouping.available !== available) {
      state.inventory_grouping.available = available;
    }
  } else {
    state.inventory_grouping = {
      available,
      value: null,
    };
  }
}
export function setInventoryGroupingValue(state, value) {
  if (typeof state.inventory_grouping !== "undefined") {
    if (state.inventory_grouping.value !== value) {
      state.inventory_grouping.value = value;
    }
  } else {
    state.inventory_grouping = {
      available: false,
      value,
    };
  }
}

export function setListingAction(state, action) {
  state.listingAction = action;
}

export function setEntryPoint(state, action) {
  state.entryPoint = action;
}

export function resetListingAction(state, action) {
  state.listingAction = null;
}

export function clearEntryPoint(state, action) {
  state.entryPoint = null;
}

export function setShowMyListings(state, show) {
  state.show_my_listings = show;
}

export function setPreviouslyPurchased(state, show) {
  state.previously_purchased = show;
}

export function setMarketplaceViewMode(state, mode) {
  state.marketplace_view_mode = mode;
}

export function setRetailerWeeklySaleSources(state, sources) {
  state.retailer_weekly_sale_sources = sources;
}
